import { c as _c } from "react/compiler-runtime";
import { QuestionMarkIcon } from '@systemeio/ui/icons';
import { FormInput, Popover, toast, Tooltip } from '@systemeio/ui';
import { createCampaign, duplicateCampaign, removeCampaign, updateCampaign } from 'modules/campaigns/api/campaign-api';
import { getCampaignStepsListNextjsUrl } from 'modules/campaigns/campaign-steps/utils/get-campaign-steps-list-nextjs-url';
import { defaultCampaignErrors } from 'modules/campaigns/constants';
import { CampaignLoco } from 'modules/campaigns/constants/campaign-loco';
import { useCampaigns } from 'modules/campaigns/hooks/use-campaign';
import { useUpdateSenderEmailAddress } from 'modules/campaigns/hooks/use-update-sender-email-address';
import { CampaignCreateInterface, CampaignErrorsInterface, CampaignInterface, CampaignUpdateInterface } from 'modules/campaigns/types/campaign-interface';
import { ShareResourceEnum } from 'modules/share/enum/share-resource-enum';
import { getShareUrl } from 'modules/share/utils/get-share-url';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { CreateDataType } from 'shared/components/create-modal';
import EditModal from 'shared/components/edit-modal';
import FormTextarea from 'shared/components/form-textarea';
import LinkShareModal from 'shared/components/link-share-modal';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import SenderEmailSelect from 'shared/components/sender-email-select';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
const defaultValues: CampaignCreateInterface = {
  name: '',
  senderEmailAddress: '',
  description: ''
};
const Campaign: NextPage = () => {
  const $ = _c(144);
  const router = useRouter();
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination();
  const {
    user
  } = useUser();
  const [errors, setErrors] = useState(defaultCampaignErrors);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== limit || $[1] !== pagination) {
    t0 = {
      limit,
      pagination
    };
    $[0] = limit;
    $[1] = pagination;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    campaigns,
    mutate,
    counter
  } = useCampaigns(t0);
  const {
    revalidateModules
  } = useRevalidateModules();
  const {
    updateSenderEmailAddress
  } = useUpdateSenderEmailAddress();
  let t1;
  if ($[3] !== t) {
    t1 = t("global.name");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = {
      key: "name",
      header: t1,
      widthPercent: 40,
      onRender: _temp
    };
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("global.description");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = {
      key: "description",
      header: t3,
      widthPercent: 30,
      onRender: _temp2
    };
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("dashboard.campaign.email_count");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = {
      key: "stepCount",
      header: t5,
      widthPercent: 15
    };
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("global.created_on");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== user?.dateFormat || $[18] !== user?.timeFormat || $[19] !== user?.timezone) {
    t8 = campaign_1 => <span>{dateTimeFormat(campaign_1.createdAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      })}</span>;
    $[17] = user?.dateFormat;
    $[18] = user?.timeFormat;
    $[19] = user?.timezone;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = {
      key: "createdAt",
      header: t7,
      widthPercent: 15,
      onRender: t8
    };
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t2 || $[25] !== t4 || $[26] !== t6 || $[27] !== t9) {
    t10 = [t2, t4, t6, t9];
    $[24] = t2;
    $[25] = t4;
    $[26] = t6;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  const columns = t10;
  let t11;
  if ($[29] !== revalidateModules) {
    t11 = async campaign_2 => {
      await removeCampaign(campaign_2.id);
      await revalidateModules([RequestModuleEnum.Campaign], true);
    };
    $[29] = revalidateModules;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const onRemoveCampaign = t11;
  let t12;
  if ($[31] !== mutate || $[32] !== revalidateModules || $[33] !== t || $[34] !== updateSenderEmailAddress) {
    t12 = async (id, campaign_3) => {
      ;
      try {
        await updateSenderEmailAddress(id, campaign_3.senderEmailAddress);
        await mutate(data => data && {
          items: data.items.map(item => {
            if (item.id === id) {
              return {
                ...item,
                senderEmailAddress: campaign_3.senderEmailAddress
              };
            }
            return item;
          }),
          hasMore: data.hasMore
        }, false);
        await revalidateModules([RequestModuleEnum.Campaign, RequestModuleEnum.CampaignStep]);
        toast.success(t("global.changes_saved"));
      } catch (t13) {
        const e = t13;
        throw e;
      }
    };
    $[31] = mutate;
    $[32] = revalidateModules;
    $[33] = t;
    $[34] = updateSenderEmailAddress;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  const onUpdateSenderEmailAddress = t12;
  let t13;
  if ($[36] !== revalidateModules) {
    t13 = async data_0 => {
      await fetchWithErrors(async () => {
        await createCampaign(data_0);
        await revalidateModules([RequestModuleEnum.Campaign], true);
      }, setErrors);
    };
    $[36] = revalidateModules;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  const onCreateCampaign = t13;
  let t14;
  if ($[38] !== mutate || $[39] !== revalidateModules) {
    t14 = async (campaign_4, newData) => {
      await fetchWithErrors(async () => {
        await updateCampaign(campaign_4.id, newData);
        await mutate(data_1 => {
          if (data_1) {
            return {
              items: data_1.items.map(item_0 => {
                if (item_0.id === campaign_4.id) {
                  item_0 = {
                    ...item_0,
                    ...newData
                  };
                }
                return item_0;
              }),
              hasMore: data_1.hasMore
            };
          }
        }, false);
        await revalidateModules([RequestModuleEnum.Campaign, RequestModuleEnum.CampaignStep]);
      }, setErrors);
    };
    $[38] = mutate;
    $[39] = revalidateModules;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  const onUpdateCampaign = t14;
  let t15;
  if ($[41] !== revalidateModules || $[42] !== router) {
    t15 = async campaign_5 => {
      const response = await duplicateCampaign(campaign_5.id);
      await revalidateModules([RequestModuleEnum.Campaign], true);
      await router.push(getCampaignStepsListNextjsUrl(response.data.id));
    };
    $[41] = revalidateModules;
    $[42] = router;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  const onDuplicateCampaign = t15;
  let t16;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => setErrors(defaultCampaignErrors);
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  const onModalClose = t16;
  let t17;
  if ($[45] !== t) {
    t17 = t("dashboard.campaign.title_plural");
    $[45] = t;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t) {
    t18 = t("dashboard.campaign.title_tooltip");
    $[47] = t;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== t18) {
    t19 = <Popover label={t18} popoverClassName="w-[200px] sm:w-[400px]">{_temp3}</Popover>;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== t17 || $[52] !== t19) {
    t20 = <h1 className="flex items-center gap-1.5">{t17}{t19}</h1>;
    $[51] = t17;
    $[52] = t19;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== onCreateCampaign) {
    t21 = data_2 => onCreateCampaign(data_2);
    $[54] = onCreateCampaign;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  let t22;
  if ($[56] !== t) {
    t22 = t("dashboard.campaign.title");
    $[56] = t;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = ["name"];
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== errors || $[60] !== t) {
    t24 = {
      field: "name",
      onRender: (value, onChange) => <FormInput required={true} placeholder={t("global.name")} key="campaign-name-create" label={t("global.name")} value={value} onChange={e_0 => onChange(e_0.target.value)} error={errors.name} />
    };
    $[59] = errors;
    $[60] = t;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== errors) {
    t25 = {
      field: "senderEmailAddress",
      onRender: (value_0, onChange_0) => <SenderEmailSelect required={true} key="campaign-sender-email" onChange={data_3 => data_3 && onChange_0(data_3)} value={value_0} error={errors.senderEmailAddress} withoutCloseIcon={true} />
    };
    $[62] = errors;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== errors || $[65] !== t) {
    t26 = {
      field: "description",
      onRender: (value_1, onChange_1) => <FormTextarea key="campaign-description-create" label={t("global.description")} placeholder={t("global.description")} value={value_1 || ""} onChange={e_1 => onChange_1(e_1.target.value)} error={errors.description} />
    };
    $[64] = errors;
    $[65] = t;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  let t27;
  if ($[67] !== t24 || $[68] !== t25 || $[69] !== t26) {
    t27 = [t24, t25, t26];
    $[67] = t24;
    $[68] = t25;
    $[69] = t26;
    $[70] = t27;
  } else {
    t27 = $[70];
  }
  let t28;
  if ($[71] !== t21 || $[72] !== t22 || $[73] !== t27) {
    t28 = {
      onCreate: t21,
      defaultValues,
      caption: t22,
      onAfterLeave: onModalClose,
      requiredFields: t23,
      creatable: t27
    };
    $[71] = t21;
    $[72] = t22;
    $[73] = t27;
    $[74] = t28;
  } else {
    t28 = $[74];
  }
  let t29;
  if ($[75] !== t) {
    t29 = t("dashboard.campaign.title");
    $[75] = t;
    $[76] = t29;
  } else {
    t29 = $[76];
  }
  let t30;
  if ($[77] !== limit || $[78] !== setLimit) {
    t30 = {
      limit,
      setLimit
    };
    $[77] = limit;
    $[78] = setLimit;
    $[79] = t30;
  } else {
    t30 = $[79];
  }
  let t31;
  if ($[80] !== pagination || $[81] !== setPagination) {
    t31 = {
      pagination,
      setPagination
    };
    $[80] = pagination;
    $[81] = setPagination;
    $[82] = t31;
  } else {
    t31 = $[82];
  }
  let t32;
  if ($[83] !== onUpdateCampaign) {
    t32 = (campaign_6, data_4) => onUpdateCampaign(campaign_6, data_4);
    $[83] = onUpdateCampaign;
    $[84] = t32;
  } else {
    t32 = $[84];
  }
  let t33;
  if ($[85] !== errors || $[86] !== t) {
    t33 = {
      field: "name",
      onRender: (value_2, onChange_2) => <FormInput key="campaign-name-edit" placeholder={t("global.name")} value={value_2} onChange={e_2 => onChange_2(e_2.target.value)} error={errors.name} label={t("global.name")} />
    };
    $[85] = errors;
    $[86] = t;
    $[87] = t33;
  } else {
    t33 = $[87];
  }
  let t34;
  if ($[88] !== errors || $[89] !== t) {
    t34 = {
      field: "description",
      onRender: (value_3, onChange_3) => <FormTextarea key="campaign-description-edit" onChange={e_3 => onChange_3(e_3.target.value)} placeholder={t("global.description")} value={value_3 || ""} label={t("global.description")} error={errors.description} className="min-h-[126px]" />
    };
    $[88] = errors;
    $[89] = t;
    $[90] = t34;
  } else {
    t34 = $[90];
  }
  let t35;
  if ($[91] !== t33 || $[92] !== t34) {
    t35 = [t33, t34];
    $[91] = t33;
    $[92] = t34;
    $[93] = t35;
  } else {
    t35 = $[93];
  }
  let t36;
  if ($[94] !== t32 || $[95] !== t35) {
    t36 = {
      onModalClose,
      onEdit: t32,
      editable: t35
    };
    $[94] = t32;
    $[95] = t35;
    $[96] = t36;
  } else {
    t36 = $[96];
  }
  let t37;
  if ($[97] !== t) {
    t37 = t("dashboard.actions.title.duplicate");
    $[97] = t;
    $[98] = t37;
  } else {
    t37 = $[98];
  }
  let t38;
  if ($[99] !== onDuplicateCampaign || $[100] !== t) {
    t38 = (opened, onClose, campaign_7, key) => <ConfirmationModal confirmationText={t("dashboard.campaign.duplicate_confirm")} key={key} opened={opened} onClose={onClose} onConfirm={() => onDuplicateCampaign(campaign_7)} toastCaption={t("global.duplicated")} />;
    $[99] = onDuplicateCampaign;
    $[100] = t;
    $[101] = t38;
  } else {
    t38 = $[101];
  }
  let t39;
  if ($[102] !== t37 || $[103] !== t38) {
    t39 = {
      name: "duplicate",
      caption: t37,
      onActionRender: t38
    };
    $[102] = t37;
    $[103] = t38;
    $[104] = t39;
  } else {
    t39 = $[104];
  }
  let t40;
  if ($[105] !== t) {
    t40 = t("dashboard.campaign.action_edit_sender_email");
    $[105] = t;
    $[106] = t40;
  } else {
    t40 = $[106];
  }
  let t41;
  if ($[107] !== errors || $[108] !== onUpdateSenderEmailAddress || $[109] !== t) {
    t41 = (opened_0, onClose_0, campaign_8, key_0) => <EditModal key={key_0} instance={campaign_8} caption={t("dashboard.campaign.edit_sender_email_title")} opened={opened_0} onClose={onClose_0} afterLeave={onModalClose} editable={[{
      field: "senderEmailAddress",
      disabled: _temp4,
      onRender: (value_5, onChange_4) => <SenderEmailSelect required={true} key="campaign-sender-email" onChange={data_5 => data_5 && onChange_4(data_5)} value={value_5} error={errors.senderEmailAddress} hintLabel={t("dashboard.campaign.edit_sender_email_hint")} withoutCloseIcon={true} />
    }]} onEdit={data_6 => onUpdateSenderEmailAddress(campaign_8.id, data_6)} />;
    $[107] = errors;
    $[108] = onUpdateSenderEmailAddress;
    $[109] = t;
    $[110] = t41;
  } else {
    t41 = $[110];
  }
  let t42;
  if ($[111] !== t40 || $[112] !== t41) {
    t42 = {
      name: "updateSenderEmailAddress",
      caption: t40,
      onActionRender: t41
    };
    $[111] = t40;
    $[112] = t41;
    $[113] = t42;
  } else {
    t42 = $[113];
  }
  let t43;
  if ($[114] !== t) {
    t43 = t("dashboard.actions.title.share");
    $[114] = t;
    $[115] = t43;
  } else {
    t43 = $[115];
  }
  let t44;
  if ($[116] !== t) {
    t44 = (opened_1, onClose_1, campaign_9, key_1) => <LinkShareModal opened={opened_1} link={getShareUrl(ShareResourceEnum.Campaign, campaign_9.hash)} title={t("dashboard.campaign.share_campaign")} label={t("dashboard.campaign.share_campaign_text")} onClose={onClose_1} key={key_1} />;
    $[116] = t;
    $[117] = t44;
  } else {
    t44 = $[117];
  }
  let t45;
  if ($[118] !== t43 || $[119] !== t44) {
    t45 = {
      name: "share",
      caption: t43,
      onActionRender: t44
    };
    $[118] = t43;
    $[119] = t44;
    $[120] = t45;
  } else {
    t45 = $[120];
  }
  let t46;
  if ($[121] !== t39 || $[122] !== t42 || $[123] !== t45) {
    t46 = [t39, t42, t45];
    $[121] = t39;
    $[122] = t42;
    $[123] = t45;
    $[124] = t46;
  } else {
    t46 = $[124];
  }
  let t47;
  if ($[125] !== onRemoveCampaign) {
    t47 = {
      onChange: campaign_10 => onRemoveCampaign(campaign_10)
    };
    $[125] = onRemoveCampaign;
    $[126] = t47;
  } else {
    t47 = $[126];
  }
  let t48;
  if ($[127] !== t36 || $[128] !== t46 || $[129] !== t47) {
    t48 = {
      settings: t36,
      custom: t46,
      remove: t47
    };
    $[127] = t36;
    $[128] = t46;
    $[129] = t47;
    $[130] = t48;
  } else {
    t48 = $[130];
  }
  let t49;
  if ($[131] !== campaigns || $[132] !== columns || $[133] !== t29 || $[134] !== t30 || $[135] !== t31 || $[136] !== t48) {
    t49 = <Table data={campaigns} columns={columns} caption={t29} limiter={t30} paginator={t31} actions={t48} />;
    $[131] = campaigns;
    $[132] = columns;
    $[133] = t29;
    $[134] = t30;
    $[135] = t31;
    $[136] = t48;
    $[137] = t49;
  } else {
    t49 = $[137];
  }
  let t50;
  if ($[138] !== campaigns || $[139] !== counter || $[140] !== t20 || $[141] !== t28 || $[142] !== t49) {
    t50 = <ListingLayout counter={counter} data={campaigns} title={t20} type="compact" createData={t28}>{t49}</ListingLayout>;
    $[138] = campaigns;
    $[139] = counter;
    $[140] = t20;
    $[141] = t28;
    $[142] = t49;
    $[143] = t50;
  } else {
    t50 = $[143];
  }
  return t50;
};
export const getServerSideProps = getBaseServerSideProps(CampaignLoco, 'header.top_menu.campaigns');
export default Campaign;
function _temp(campaign) {
  return <LinkWithoutPrefetch className="primary-link w-full" href={getCampaignStepsListNextjsUrl(campaign.id)}><Tooltip labelClassName="max-w-xl" mode="overflow" label={campaign.name ?? ""} className="truncate">{campaign.name}</Tooltip></LinkWithoutPrefetch>;
}
function _temp2(campaign_0) {
  return <Tooltip labelClassName="max-w-xl" mode="overflow" label={campaign_0.description ?? ""} className="truncate">{campaign_0.description}</Tooltip>;
}
function _temp3(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary`} />;
}
function _temp4(value_4) {
  return value_4 === null;
}